import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  unitsOfMeasure: [
    {id: 1, name: 'Lineal Metre'},
    {id: 2, name: 'Each'}],
  type: {
    product: [
      {id: 1, name: 'HWS Gas Storage'},
      {id: 2, name: 'HWS Electric Storage'},
      {id: 3, name: 'HWS Gas Continuous Flow'},
      {id: 4, name: 'HWS Electric Continuous Flow'},
      {id: 5, name: 'HWS Solar Gas Boosted'},
      {id: 6, name: 'HWS Solar Electric Boosted'},
      {id: 7, name: 'HWS Heat Pump'},
      {id: 8, name: 'HWS Boiling / Chilled'},
      {id: 9, name: 'HWS Commercial'},
      {id: 10, name: 'Tap Mixer Basin'},
      {id: 11, name: 'Tap Mixer Sink'},
      {id: 12, name: 'Tap Mixer Sink with Pull Out'},
      {id: 13, name: 'Tap Mixer Wall'},
      {id: 14, name: 'Tap Mixer Wall & Spout Combined'},
      {id: 15, name: 'Tap Mixer Bath Floor Mounted'},
      {id: 16, name: 'Tap Wall Top Assembly'},
      {id: 17, name: 'Tap Hob Top Assembly'},
      {id: 18, name: 'Tap Set Basin'},
      {id: 19, name: 'Tap Set Shower'},
      {id: 20, name: 'Tap Set Bath'},
      {id: 21, name: 'Tap Set Sink'},
      {id: 22, name: 'Tap Set Washing Machine Stop'},
      {id: 23, name: 'Tap Outlet Basin'},
      {id: 24, name: 'Tap Outlet Shower Hand / Head / Arm'},
      {id: 25, name: 'Tap Outlet Shower Rail'},
      {id: 26, name: 'Tap Outlet Bath / Spa'},
      {id: 27, name: 'Tap Outlet Sink'},
      {id: 28, name: 'Tap Pillar'},
      {id: 29, name: 'Tap Filter'},
      {id: 30, name: 'Tap Bidet'},
      {id: 31, name: 'Tap Care / Commercial'},
      {id: 32, name: 'Toilet CC Suite'},
      {id: 33, name: 'Toilet CC Back to Wall Suite'},
      {id: 34, name: 'Toilet Linked Suite'},
      {id: 35, name: 'Toilet Skew Suite'},
      {id: 36, name: 'Toilet Cistern'},
      {id: 37, name: 'Toilet Cistern in Wall Concealed'},
      {id: 38, name: 'Toilet Pan'},
      {id: 39, name: 'Toilet Seat'},
      {id: 40, name: 'Toilet Bidet'},
      {id: 41, name: 'Toilet Urinal'},
      {id: 42, name: 'Toilet Smart'},
      {id: 43, name: 'Toilet Care / Commercial'},
      {id: 44, name: 'Sink Single Bowl'},
      {id: 45, name: 'Sink Double Bowl'},
      {id: 46, name: 'Sink Granite'},
      {id: 47, name: 'Sink Ceramic'},
      {id: 48, name: 'Trough Single Bowl'},
      {id: 49, name: 'Trough Double Bowl'},
      {id: 50, name: 'Trough / Sink & Cabinet'},
      {id: 51, name: 'Trough / Sink Commercial'},
      {id: 52, name: 'Vanity Unit Floor Mounted Single Bowl'},
      {id: 53, name: 'Vanity Unit Floor Mounted Double Bowl'},
      {id: 54, name: 'Vanity Unit Wall Hung Single Bowl'},
      {id: 55, name: 'Vanity Unit Wall Hung Double Bowl'},
      {id: 56, name: 'Vanity Top'},
      {id: 57, name: 'Basin Above Counter / Vessel'},
      {id: 58, name: 'Basin Inset'},
      {id: 59, name: 'Basin Semi Recessed'},
      {id: 60, name: 'Basin Under Counter'},
      {id: 61, name: 'Basin Wall Mounted'},
      {id: 62, name: 'Basin Pedestal / Shroud'},
      {id: 63, name: 'Basin Floor Mounted'},
      {id: 64, name: 'Basin / Vanity Care / Commercial'},
      {id: 65, name: 'Bath Freestanding'},
      {id: 66, name: 'Bath Back to Wall'},
      {id: 67, name: 'Bath Inset'},
      {id: 68, name: 'Bath Corner'},
      {id: 69, name: 'Bath / Spa Screen'},
      {id: 70, name: 'Spa Freestanding'},
      {id: 71, name: 'Spa Inset'},
      {id: 72, name: 'Spa Corner'},
      {id: 73, name: 'Shower Base'},
      {id: 74, name: 'Shower Screen Framed'},
      {id: 75, name: 'Shower Screen Semi Frameless'},
      {id: 76, name: 'Shower Screen Frameless'},
      {id: 77, name: 'Shower Outdoor'},
      {id: 78, name: 'Floor Waste / Channel'},
      {id: 79, name: 'Plug & Waste'},
      {id: 80, name: 'Bottle Trap'},
      {id: 81, name: 'Bathroom Appliance'},
      {id: 82, name: 'Bathroom Accessory'},
      {id: 83, name: 'Dishwasher'},
      {id: 84, name: 'Washing Machine'},
      {id: 85, name: 'Cooktop'},
      {id: 86, name: 'Upright Cooker'},
      {id: 87, name: 'Rangehood'},
      {id: 88, name: 'Waste Disposer'},
      {id: 89, name: 'Kitchen Appliance Other'},
      {id: 90, name: 'Pump Multistage / Pressure'},
      {id: 91, name: 'Pump Jet'},
      {id: 92, name: 'Pump Submersible'},
      {id: 93, name: 'Pump Controller'},
      {id: 94, name: 'Pump Circulation'},
      {id: 95, name: 'Tank Rainwater'},
      {id: 96, name: 'Tank Septic'},
      {id: 97, name: 'Lifting Station'},
      {id: 98, name: 'Macerator'},
      {id: 99, name: 'Grease Trap'},
      {id: 100, name: 'Ducted Heater'},
      {id: 101, name: 'Wall Furnace / Space Heater'},
      {id: 102, name: 'Portable Space Heater'},
      {id: 103, name: 'Evaporative Cooling'},
      {id: 104, name: 'Heating & Cooling Other'},
      {id: 105, name: 'Refrigeration'},
      {id: 106, name: 'Irrigation'},
      {id: 107, name: 'Pool & Spa'},
      {id: 108, name: 'Fire'}
    ],
    pipe: [
      {id: 1000, order_id: 81, name: 'Pipe ABS'},
      {id: 1001, order_id: 82, name: 'Pipe Chrome Plated'},
      {id: 1002, order_id: 83, name: 'Pipe Concrete'},
      {id: 1003, order_id: 84, name: 'Pipe Copper Type A'},
      {id: 1004, order_id: 85, name: 'Pipe Copper Type B'},
      {id: 1005, order_id: 86, name: 'Pipe Copper Refrigerant Grade'},
      {id: 1006, order_id: 87, name: 'Pipe Ductile Iron'},
      {id: 1007, order_id: 88, name: 'Pipe Flexible Drain system'},
      {id: 1008, order_id: 89, name: 'Pipe Nylon'},
      {id: 1009, order_id: 90, name: 'Pipe PB ( Polybutylene )'},
      {id: 1010, order_id: 91, name: 'Pipe PE ( Polyethylene )'},
      {id: 1011, order_id: 92, name: 'Pipe HD-PE ( High Density Polyethylene )'},
      {id: 1012, order_id: 93, name: 'Pipe LD-PE ( Low Density Polyethylene )'},
      {id: 1013, order_id: 94, name: 'Pipe PE-X Crimp'},
      {id: 1014, order_id: 95, name: 'Pipe PE-X Push Fit'},
      {id: 1015, order_id: 96, name: 'Pipe PE-X Sleeve'},
      {id: 1016, order_id: 97, name: 'Pipe PE-X / AL / PE-X'},
      {id: 1017, order_id: 98, name: 'Pipe PP ( Polypropylene )'},
      {id: 1018, order_id: 99, name: 'Pipe PVC DWV'},
      {id: 1019, order_id: 100, name: 'Pipe PVC Stormwater'},
      {id: 1020, order_id: 101, name: 'Pipe PVC-M Pressure'},
      {id: 1021, order_id: 102, name: 'Pipe PVC-O Pressure'},
      {id: 1022, order_id: 103, name: 'Pipe PVC-U Pressure'},
      {id: 1023, order_id: 104, name: 'Pipe Steel Galvanised'},
      {id: 1024, order_id: 105, name: 'Pipe Steel Stainless'},
      {id: 1025, order_id: 106, name: 'Pipe Steel Other'},
      {id: 1026, order_id: 107, name: 'Pipe Storm Drain Grate'},
      {id: 1027, order_id: 108, name: 'Pipe Other'},
      {id: 1031, order_id: 4, name: 'Downpipe PVC'},
      {id: 1032, order_id: 5, name: 'Downpipe Round'},
      {id: 1033, order_id: 6, name: 'Downpipe Square'},
      {id: 1034, order_id: 7, name: 'Downpipe Other'},
      {id: 1035, order_id: 16, name: 'Facia Board'},
      {id: 1036, order_id: 19, name: 'Flashing Metal'},
      {id: 1037, order_id: 22, name: 'Flashing Other'},
      {id: 1038, order_id: 23, name: 'Gutter Concealed'},
      {id: 1039, order_id: 24, name: 'Gutter Facia / Square'},
      {id: 1040, order_id: 25, name: 'Gutter Flat Back Half Round'},
      {id: 1041, order_id: 27, name: 'Gutter Half Round'},
      {id: 1042, order_id: 28, name: 'Gutter OGEE'},
      {id: 1043, order_id: 29, name: 'Gutter PVC'},
      {id: 1044, order_id: 30, name: 'Gutter Quad'},
      {id: 1045, order_id: 31, name: 'Gutter Valley'},
      {id: 1046, order_id: 32, name: 'Gutter Other'},
      {id: 1049, order_id: 80.1, name: 'Heating & Cooling Duct'},
      {id: 1050, order_id: 165.1, name: 'Roof Capping Barge'},
      {id: 1051, order_id: 165.2, name: 'Roof Capping Top Ridge'},
      {id: 1052, order_id: 165.3, name: 'Roof Capping Other'},
      {id: 1053, order_id: 58, name: 'Hardware Hose Tube / Inlet / Outlet'},
      {id: 1054, order_id: 168, name: 'Roof Sheet Metal'},
      {id: 1055, order_id: 169, name: 'Roof Sheet Poly / Fibreglass'},
      {id: 1056, order_id: 18, name: 'Flashing Lead Roll & Square'},
      {id: 1057, order_id: 20, name: 'Flashing Non Lead'},
      {id: 1058, order_id: 21, name: 'Flashing Roof Penetration'},
      {id: 1059, order_id: 26, name: 'Gutter Guard / Leaf Protection'},
    ],
    fitting: [
      {id: 2000, order_id: 109, name: 'Pipe Fitting ABS'},
      {id: 2001, order_id: 110, name: 'Pipe Fitting Brass Capillary & Brass Tube Bush'},
      {id: 2002, order_id: 111, name: 'Pipe Fitting Brass Screwed'},
      {id: 2003, order_id: 112, name: 'Pipe Fitting Brass Flared'},
      {id: 2085, order_id: 112.1, name: 'Pipe Fitting Brass Flared Assembly / Breech'},
      {id: 2004, order_id: 113, name: 'Pipe Fitting Brass Nylon Olive'},
      {id: 2005, order_id: 114, name: 'Pipe Fitting Brass Copper Olive'},
      {id: 2006, order_id: 115, name: 'Pipe Fitting Brass Conetite'},
      {id: 2007, order_id: 116, name: 'Pipe Fitting Chrome Screwed'},
      {id: 2008, order_id: 117, name: 'Pipe Fitting Chrome Flared'},
      {id: 2009, order_id: 118, name: 'Pipe Fitting Chrome Nylon Olive'},
      {id: 2010, order_id: 119, name: 'Pipe Fitting Chrome Copper Olive'},
      {id: 2011, order_id: 120, name: 'Pipe Fitting Chrome Conetite'},
      {id: 2012, order_id: 80.1, name: 'Heating & Cooling Air Diffusion'},
      {id: 2013, order_id: 122, name: 'Pipe Fitting Concrete'},
      {id: 2086, order_id: 122.1, name: 'Pipe Fitting Copper Benders ( Manually )'},
      {id: 2014, order_id: 123, name: 'Pipe Fitting Copper & Copper Capillary'},
      {id: 2087, order_id: 123.1, name: 'Pipe Fitting Cooper Capillary Assembly / Breech'},
      {id: 2015, order_id: 124, name: 'Pipe Fitting Copper Press'},
      {id: 2016, order_id: 125, name: 'Pipe Fitting Copper Push Fit'},
      {id: 2017, order_id: 125, name: 'Pipe Fitting Copper Refrigerant Grade'},
      {id: 2018, order_id: 126, name: 'Pipe Fitting Ductile Iron'},
      {id: 2019, order_id: 127, name: 'Pipe Fitting Flexible Drain system'},
      {id: 2020, order_id: 128, name: 'Pipe Fitting Mound & Grate'},
      {id: 2021, order_id: 129, name: 'Pipe Fitting Nylon'},
      {id: 2022, order_id: 130, name: 'Pipe Fitting PB ( Polybutylene )'},
      {id: 2023, order_id: 131, name: 'Pipe Fitting PE ( Polyethylene ) Compression'},
      {id: 2024, order_id: 132, name: 'Pipe Fitting PE ( Polyethylene ) Push Fit'},
      {id: 2025, order_id: 133, name: 'Pipe Fitting PE ( Polyethylene ) Electrofusion & Butt Weld'},
      {id: 2026, order_id: 134, name: 'Pipe Fitting PE ( Polyethylene ) Rural'},
      {id: 2035, order_id: 134.1, name: 'Pipe Fitting PE ( Polyethylene ) Screwed'},
      {id: 2027, order_id: 135, name: 'Pipe Fitting PE ( Polyethylene ) Other'},
      {id: 2028, order_id: 136, name: 'Pipe Fitting HDPE ( High Density Polyethylene ) Electrofusion & Butt Weld'},
      {id: 2029, order_id: 137, name: 'Pipe Fitting HDPE ( High Density Polyethylene ) Other'},
      {id: 2030, order_id: 138, name: 'Pipe Fitting LDPE ( Low Density Polyethylene )'},
      {id: 2031, order_id: 139, name: 'Pipe Fitting PE-X Crimp'},
      {id: 2088, order_id: 139.1, name: 'Pipe Fitting PE-X Crimp Assembly / Breech'},
      {id: 2032, order_id: 140, name: 'Pipe Fitting PE-X Push Fit'},
      {id: 2089, order_id: 140.1, name: 'Pipe Fitting PE-X Push Fit Assembly / Breech'},
      {id: 2033, order_id: 141, name: 'Pipe Fitting PE-X Sleeve'},
      {id: 2090, order_id: 141.1, name: 'Pipe Fitting PE-X Sleeve Assembly / Breech'},
      {id: 2034, order_id: 142, name: 'Pipe Fitting PE-X / AL / PE-X'},
      {id: 2036, order_id: 144, name: 'Pipe Fitting PP ( Polypropylene )'},
      {id: 2037, order_id: 145, name: 'Pipe Fitting PVC DWV '},
      {id: 2038, order_id: 146, name: 'Pipe Fitting PVC Stormwater'},
      {id: 2039, order_id: 147, name: 'Pipe Fitting PVC-M Pressure'},
      {id: 2040, order_id: 148, name: 'Pipe Fitting PVC-O Pressure'},
      {id: 2041, order_id: 149, name: 'Pipe Fitting PVC-U Pressure'},
      {id: 2042, order_id: 150, name: 'Pipe Fitting Repair Clamp'},
      {id: 2043, order_id: 151, name: 'Pipe Fitting Rubber Connector'},
      {id: 2091, order_id: 151.1, name: 'Pipe Fitting Smart Pan / Leak Control'},
      {id: 2044, order_id: 152, name: 'Pipe Fitting Steel Galvanised'},
      {id: 2045, order_id: 153, name: 'Pipe Fitting Steel Stainless Press'},
      {id: 2046, order_id: 154, name: 'Pipe Fitting Steel Other'},
      {id: 2047, order_id: 155, name: 'Pipe Fitting Storm Drain Grate'},
      {id: 2048, order_id: 156, name: 'Pipe Fitting Tapping Band'},
      {id: 2049, order_id: 158, name: 'Pipe Fitting Other'},
      {id: 2092, order_id: 158.1, name: 'Pipe Fixing Back Nut / Flange'},
      {id: 2050, order_id: 8, name: 'Downpipe Fitting PVC'},
      {id: 2051, order_id: 9, name: 'Downpipe Fitting Round'},
      {id: 2052, order_id: 10, name: 'Downpipe Fitting Square'},
      {id: 2053, order_id: 11, name: 'Downpipe Fitting Other'},
      {id: 2079, order_id: 11.1, name: 'Downpipe Join / Angle ( Manually )'},
      {id: 2054, order_id: 16, name: 'Facia Board Fitting'},
      {id: 2080, order_id: 16.1, name: 'Facia Board Join / Angle ( Manually )'},
      {id: 2055, order_id: 59.3, name: 'Hardware Irrigation Sprinkler'},
      {id: 2056, order_id: 34, name: 'Gutter Fitting Facia / Square'},
      {id: 2057, order_id: 35, name: 'Gutter Fitting Flat Back Hard Round'},
      {id: 2058, order_id: 36, name: 'Gutter Fitting Half Round'},
      {id: 2059, order_id: 37, name: 'Gutter Fitting OGEE'},
      {id: 2060, order_id: 38, name: 'Gutter Fitting Plastic'},
      {id: 2061, order_id: 39, name: 'Gutter Fitting Quad'},
      {id: 2062, order_id: 40, name: 'Gutter Fitting Other'},
      {id: 2081, order_id: 40.1, name: 'Gutter Join / Angle ( Manually )'},
      {id: 2063, order_id: 51, name: 'Hardware Cover Plate'},
      {id: 2064, order_id: 52.3, name: 'Hardware Fire Sprinkler'},
      {id: 2065, order_id: 61, name: 'Hardware Mound & Grate / Finishing Collar'},
      {id: 2066, order_id: 62, name: 'Hardware Pit & Grate'},
      {id: 2082, order_id: 72.1, name: 'Hardware Pipe Insulation / Lagging'},
      {id: 2068, order_id: 126.1, name: 'Pipe Fitting Ferrule'},
      {id: 2069, order_id: 157, name: 'Pipe Fitting Test Plug'},
      {id: 2097, order_id: 157.1, name: 'Pipe Fitting Trap / Waste'},
      {id: 2070, order_id: 80.3, name: 'Heating & Cooling Duct Fitting'},
      {id: 2071, order_id: 115.1, name: 'Pipe Fitting Breach Cooper Capillary'},
      {id: 2077, order_id: 127.1, name: 'Pipe Fitting Hose Barb'},
      {id: 2083, order_id: 19.1, name: 'Flashing Join / Angle ( Manually )'},
      {id: 2084, order_id: 71.1, name: 'Hardware Signs / Pipe Markers'},
      {id: 2093, order_id: 55, name: 'Hardware Gas Meter'},
      {id: 2094, order_id: 78, name: 'Hardware Water Meter'},
      {id: 2095, order_id: 79, name: 'Hardware Water Tank Spare Part / Accessory'},
      {id: 2096, order_id: 167, name: 'Roof Insulation & Underlay'},
    ],
    fixing: [
      {id: 3000, order_id: 12, name: 'Downpipe Fixing PVC'},
      {id: 3001, order_id: 13, name: 'Downpipe Fixing Round'},
      {id: 3002, order_id: 14, name: 'Downpipe Fixing Square'},
      {id: 3003, order_id: 15, name: 'Downpipe Fixing Other'},
      {id: 3004, order_id: 17, name: 'Facia Board Fixing'},
      {id: 3005, order_id: 41, name: 'Gutter Fixing Box'},
      {id: 3006, order_id: 42, name: 'Gutter Fixing Facia / Square'},
      {id: 3007, order_id: 43, name: 'Gutter Fixing Flat Back Half Round'},
      {id: 3008, order_id: 44, name: 'Gutter Fixing Half Round'},
      {id: 3009, order_id: 45, name: 'Gutter Fixing OGEE'},
      {id: 3010, order_id: 46, name: 'Gutter Fixing Plastic'},
      {id: 3011, order_id: 47, name: 'Gutter Fixing Quad'},
      {id: 3012, order_id: 48, name: 'Gutter Fixing Other'},
      {id: 3013, order_id: 49, name: 'Hardware Adhesive / Sealant'},
      {id: 3014, order_id: 50, name: 'Hardware Anchor / Screw / Rivet'},
      {id: 3015, order_id: 158, name: 'Pipe Fixing Bracket'},
      {id: 3016, order_id: 159, name: 'Pipe Fixing Bracket & Clip Combination'},
      {id: 3017, order_id: 160, name: 'Pipe Fixing Clip Bolted'},
      {id: 3018, order_id: 161, name: 'Pipe Fixing Clip Head'},
      {id: 3019, order_id: 162, name: 'Pipe Fixing Clip PE-X'},
      {id: 3020, order_id: 163, name: 'Pipe Fixing Clip Saddle'},
      {id: 3024, order_id: 163.1, name: 'Pipe Fixing Hose Clip'},
      {id: 3025, order_id: 163.2, name: 'Pipe Fixing PE-X Support'},
      {id: 3021, order_id: 164, name: 'Pipe Fixing Plate / Rod'},
      {id: 3026, order_id: 164.1, name: 'Pipe Fixing Noggin'},
      {id: 3027, order_id: 164.2, name: 'Pipe Fixing Core Drill Hole ( Manually )'},
      {id: 3022, order_id: 165, name: 'Pipe Fixing Other'},
      {id: 3023, order_id: 79.1, name: 'Hardware Waterproofing'},
      {id: 3034, order_id: 70, name: 'Hardware Sand & Cement / Concrete'},
      {id: 3035, order_id: 71, name: 'Hardware Screening / Crushed Rock'},
      {id: 3036, order_id: 75, name: 'Hardware Tool / Welding / Blade / Drill Bit'},
      {id: 3037, order_id: 170, name: 'Roof Sheet Fixing / Installation Hardware'}
    ],
    other: [
      // {id: 4000, order_id: 18, name: 'Flashing Lead Roll & Square'},
      // {id: 4001, order_id: 20, name: 'Flashing Non Lead'},
      // {id: 4002, order_id: 21, name: 'Flashing Roof Penetration'},
      // {id: 4003, order_id: 26, name: 'Gutter Guard / Leaf Protection'},
      {id: 4004, order_id: 52, name: 'Hardware Chemical Drain Cleaner'},
      {id: 4005, order_id: 53, name: 'Hardware Fitting Spare Part / Accessory'},
      {id: 4007, order_id: 56, name: 'Hardware Hose Flexible Gas'},
      {id: 4008, order_id: 57, name: 'Hardware Hose Flexible Water'},
      {id: 4010, order_id: 59, name: 'Hardware Hot Water System Spare Part / Accessory'},
      {id: 4011, order_id: 60, name: 'Hardware LPG'},
      {id: 4012, order_id: 0, name: 'Compliance Certificate & Miscellaneous'},
      {id: 4075, order_id: 1, name: 'Hire Equipment / Tool'},
      {id: 4013, order_id: 64, name: 'Hardware Poly Base / Concrete Slab'},
      {id: 4014, order_id: 65, name: 'Hardware Pool & Spa Spare Part / Accessory'},
      {id: 4015, order_id: 66, name: 'Hardware Pump Spare Part / Accessory'},
      {id: 4016, order_id: 67, name: 'Hardware Refrigeration Spare Part / Accessory'},
      {id: 4017, order_id: 52.1, name: 'Hardware Fire Spare Part / Accessory'},
      {id: 4018, order_id: 69, name: 'Hardware Safetray'},
      {id: 4021, order_id: 73, name: 'Hardware Tap Spare Part / Accessory'},
      {id: 4022, order_id: 74, name: 'Hardware Toilet Spare Part / Accessory'},
      {id: 4024, order_id: 76, name: 'Hardware Valve Spare Part / Accessory'},
      {id: 4025, order_id: 77, name: 'Hardware Water Filtration'},
      {id: 4028, order_id: 80, name: 'Hardware Other'},
      {id: 4029, order_id: 166, name: 'Roof Rain Head'},
      {id: 4034, order_id: 171, name: 'Roof Skylight'},
      {id: 4035, order_id: 172, name: 'Roof Ventilation'},
      {id: 4036, order_id: 173, name: 'Roof Other'},
      {id: 4077, order_id: 173.1, name: 'Sewer & Drainage'},
      {id: 4037, order_id: 174, name: 'Valve Actuation'},
      {id: 4038, order_id: 175, name: 'Valve Air Admittance'},
      {id: 4039, order_id: 176, name: 'Valve Backflow / Vacuum Breaker / Check'},
      {id: 4040, order_id: 177, name: 'Valve Balancing'},
      {id: 4041, order_id: 178, name: 'Valve Ball Gas'},
      {id: 4042, order_id: 179, name: 'Valve Butterfly'},
      {id: 4043, order_id: 180, name: 'Valve Duo / Nri Valve'},
      {id: 4044, order_id: 181, name: 'Valve Expansion Control'},
      {id: 4045, order_id: 182, name: 'Valve Fire'},
      {id: 4046, order_id: 183, name: 'Valve Float'},
      {id: 4047, order_id: 184, name: 'Valve Gas Bayonet'},
      {id: 4048, order_id: 185, name: 'Valve Gas Regulator'},
      {id: 4049, order_id: 52.2, name: 'Hardware Fire Collar'},
      {id: 4050, order_id: 187, name: 'Valve Gate'},
      {id: 4051, order_id: 188, name: 'Valve Globe'},
      {id: 4052, order_id: 189, name: 'Valve Hammer Arrestor'},
      {id: 4053, order_id: 190, name: 'Valve Mini Stop / W.M Stop / Combi'},
      {id: 4054, order_id: 191, name: 'Valve Noise Reduction'},
      {id: 4055, order_id: 192, name: 'Valve Plastic'},
      {id: 4056, order_id: 193, name: 'Valve Pressure Limiting'},
      {id: 4057, order_id: 194, name: 'Valve Pressure Reducing'},
      {id: 4058, order_id: 195, name: 'Valve P&T Relief'},
      {id: 4059, order_id: 196, name: 'Valve Refrigeration'},
      {id: 4060, order_id: 197, name: 'Valve Sluice'},
      {id: 4061, order_id: 198, name: 'Valve Solar'},
      {id: 4062, order_id: 199, name: 'Valve Strainer'},
      {id: 4063, order_id: 200, name: 'Valve Tempering'},
      {id: 4064, order_id: 201, name: 'Valve T-Head Stop / Bib / Garden'},
      {id: 4065, order_id: 202, name: 'Valve Thermostatic Mixing'},
      {id: 4066, order_id: 203, name: 'Valve Other'},
      {id: 4067, order_id: 59.1, name: 'Hardware Hot Water System Flue'},
      {id: 4068, order_id: 59.2, name: 'Hardware Irrigation Spare Part / Accessory'},
      {id: 4069, order_id: 80.4, name: 'Heating & Cooling Ventilation'},
      {id: 4070, order_id: 80.5, name: 'Heating & Cooling Installation Hardware'},
      {id: 4071, order_id: 80.6, name: 'Heating & Cooling Spare Part / Accessory'},
      {id: 4072, order_id: 80.7, name: 'Heating & Cooling Other'},
      {id: 4073, order_id: 172.1, name: 'Roof Spare Part / Accessory'},
      {id: 4074, order_id: 178.1, name: 'Valve Ball Water'},
      {id: 4076, order_id: 198.1, name: 'Valve Solenoid'}
    ]
  },
  qty: [
    {id: 0, name: 0},
    {id: 0.25, name: '0.25'},
    {id: 0.50, name: '0.50'},
    {id: 0.75, name: '0.75'},
    {id: 1.00, name: '1.00'},
    {id: 1.25, name: '1.25'},
    {id: 1.50, name: '1.50'},
    {id: 1.75, name: '1.75'},
    {id: 2.00, name: '2.00'},
    {id: 3.00, name: '3.00'},
    {id: 4.00, name: '4.00'},
    {id: 5.00, name: '5.00'},
    {id: 6.00, name: '6.00'},
    {id: 7.00, name: '7.00'},
    {id: 8.00, name: '8.00'},
    {id: 9.00, name: '9.00'},
    {id: 10.00, name: '10.00'},
    {id: 11.00, name: '11.00'},
    {id: 12.00, name: '12.00'},
    {id: 13.00, name: '13.00'},
    {id: 14.00, name: '14.00'},
    {id: 15.00, name: '15.00'},
    {id: 16.00, name: '16.00'},
    {id: 17.00, name: '17.00'},
    {id: 18.00, name: '18.00'},
    {id: 19.00, name: '19.00'},
    {id: 20.00, name: '20.00'}
  ],
  time_complete: [
    {id: 0, name: '0 Min'},
    {id: 0.5, name: '0.5 Min'},
    {id: 1, name: '1 Min'},
    {id: 2, name: '2 Min'},
    {id: 3, name: '3 Min'},
    {id: 4, name: '4 Min'},
    {id: 5, name: '5 Min'},
    {id: 6, name: '6 Min'},
    {id: 7, name: '7 Min'},
    {id: 8, name: '8 Min'},
    {id: 9, name: '9 Min'},
    {id: 10, name: '10 Min'},
    {id: 11, name: '11 Min'},
    {id: 12, name: '12 Min'},
    {id: 13, name: '13 Min'},
    {id: 14, name: '14 Min'},
    {id: 15, name: '15 Min'},
    {id: 16, name: '16 Min'},
    {id: 17, name: '17 Min'},
    {id: 18, name: '18 Min'},
    {id: 19, name: '19 Min'},
    {id: 20, name: '20 Min'},
    {id: 21, name: '21 Min'},
    {id: 22, name: '22 Min'},
    {id: 23, name: '23 Min'},
    {id: 24, name: '24 Min'},
    {id: 25, name: '25 Min'},
    {id: 26, name: '26 Min'},
    {id: 27, name: '27 Min'},
    {id: 28, name: '28 Min'},
    {id: 29, name: '29 Min'},
    {id: 30, name: '30 Min'},
    {id: 31, name: '31 Min'},
    {id: 32, name: '32 Min'},
    {id: 33, name: '33 Min'},
    {id: 34, name: '34 Min'},
    {id: 35, name: '35 Min'},
    {id: 36, name: '36 Min'},
    {id: 37, name: '37 Min'},
    {id: 38, name: '38 Min'},
    {id: 39, name: '39 Min'},
    {id: 40, name: '40 Min'},
    {id: 41, name: '41 Min'},
    {id: 42, name: '42 Min'},
    {id: 43, name: '43 Min'},
    {id: 44, name: '44 Min'},
    {id: 45, name: '45 Min'},
    {id: 46, name: '46 Min'},
    {id: 47, name: '47 Min'},
    {id: 48, name: '48 Min'},
    {id: 49, name: '49 Min'},
    {id: 50, name: '50 Min'},
    {id: 51, name: '51 Min'},
    {id: 52, name: '52 Min'},
    {id: 53, name: '53 Min'},
    {id: 54, name: '54 Min'},
    {id: 55, name: '55 Min'},
    {id: 56, name: '56 Min'},
    {id: 57, name: '57 Min'},
    {id: 58, name: '58 Min'},
    {id: 59, name: '59 Min'}
  ],
  size: [
    {id: 0, name: 'n/a'},
    {id: 9, prev: 0, name: '0mm - 9mm'},
    {id: 14, prev: 9, name: '10mm - 14mm'},
    {id: 19, prev: 14, name: '15mm - 19mm'},
    {id: 24, prev: 19, name: '20mm - 24mm'},
    {id: 31, prev: 24, name: '25mm - 31mm'},
    {id: 39, prev: 31, name: '32mm - 39mm'},
    {id: 49, prev: 39, name: '40mm - 49mm'},
    {id: 64, prev: 49, name: '50mm - 64mm'},
    {id: 74, prev: 64, name: '65mm - 74mm'},
    {id: 79, prev: 74, name: '75mm - 79mm'},
    {id: 89, prev: 79, name: '80mm - 89mm'},
    {id: 99, prev: 89, name: '90mm - 99mm'},
    {id: 109, prev: 99, name: '100mm - 109mm'},
    {id: 124, prev: 109, name: '110mm - 124mm'},
    {id: 149, prev: 124, name: '125mm - 149mm'},
    {id: 159, prev: 149, name: '150mm - 159mm'},
    {id: 199, prev: 159, name: '160mm - 199mm'},
    {id: 224, prev: 199, name: '200mm - 224mm'},
    {id: 249, prev: 224, name: '225mm - 249mm'},
    {id: 299, prev: 249, name: '250mm - 299mm'},
    {id: 374, prev: 374, name: '300mm - 374mm'},
    {id: 449, prev: 449, name: '375mm - 449mm'},
    {id: 599, prev: 599, name: '450mm - 599mm'},
    {id: 799, prev: 799, name: '600mm - 799mm'},
    {id: 1200, prev: 1200, name: '800mm - 1200mm'}
  ]
}

export default {
  state,
  getters,
  mutations,
  actions
}
